export default function SkeletonCard() {
  return (
    <div className="animate-pulse">
      <div className="aspect-video w-full rounded-lg bg-background-200" />
      <div className="mt-3 h-3.5 w-3/4 rounded bg-background-200" />
      <div className="mt-2 h-3 w-full rounded bg-background-100" />
      <div className="mt-2 h-3 w-2/3 rounded bg-background-100" />
    </div>
  );
}